/*
 *  Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import { Helmet } from "react-helmet-async";
import { LpMetaProps } from "../../../../../types/LpMetaProps";
import { gaSet } from "../../../../../services/googleAnalyticsService";

const LpTrafficOtherPageMeta = ({ keyword }: LpMetaProps) => {
  const title = keyword + " | Legalbird";
  gaSet({ title: title });

  return (
    <Helmet>
      <title>{title}</title>
      <meta
        name="description"
        content="Handy, Drogen oder Alkohol am Steuer? Falsch geparkt? Lassen Sie Ihren Bußgeldbescheid online prüfen! - Schnell, einfach und sicher!"
      />
      <meta
        name="keywords"
        content="Handy am Steuer, Alkohol, Falschparken, Verkehrsrecht, Bußgeld, Bußgeldbescheid, Anhörungsbogen, geblitzt, Ordnungswidrigkeit, Fahrverbot"
      />
      <meta name="robots" content="noindex,nofollow" />
      <meta property="og:title" content={title} />
      <meta property="og:locale" content="de_DE" />
      <meta property="og:type" content="website" />
      <meta
        property="og:description"
        content="Sie wurden mit Handy am Steuer erwischt? Lassen Sie Ihren Bußgeldbescheid online prüfen! - Schnell, einfach und sicher!"
      />
    </Helmet>
  );
};

export default LpTrafficOtherPageMeta;
